module.exports = __webpack_public_path__ + "static/media/serviceIndustry2.36c1306f.png";